__turbopack_context__.v({
  "btn-next": "EfuKIa_btn-next",
  "btn-prev": "EfuKIa_btn-prev",
  "container-img": "EfuKIa_container-img",
});
